import React from "react";
import "./PrivacyPolicy.css"
import Header from "../../../../Components/UserAuth/Header";
const PrivacyPolicy = (props) => {
 return(
    <div className="main-container">
       <Header/>
       <div className="privacy-policy-container">
            <div className="policy-main-header">
                Privacy Policy
            </div>
            <div className="policy-text">
            This privacy policy ("Policy") describes how the website/application operator ("Website Operator", "we", "us" or "our") collects, protects and uses the personally identifiable information ("Personal Information") you ("User", "you" or "your") may provide on the website and any of its products or services (collectively, "Website" or "Services"). It also describes the choices available to you regarding our use of your personal information and how you can access and update this information.
            </div>
            <div className="policy-sub-header">
                Collection of personal information:
            </div>
            <div className="policy-text">
                We may collect the following personal information from you:
                <ul>
                    <li>
                    Contact Information such as name, email address, mailing address, phone number which will be used for user profile maintenance and to associate user properties with the entered user information.
                    </li>
                    <li>
                    Location information which would be used to identify the location of the property. This is up to the user and can be disabled at any time if they wish for us to no longer use this information.
                    </li>
                    <li>
                    Photographs which are provided by you to provide you with the required services, please note that the user can choose at any given time to not provide us with this information, if they decide to do so.
                    </li>
                    <li>
                    No such information that tracks your “usage data” and things like IP address, browser type, operating system, cookies data, and device Unique ID or any other apps that are being used by the user are not a part of the information that we collect.
                    </li>
                    <li>
                    Information about your use of the Website and the Services are being kept to keep a log of user activity strictly within the provided services.
                    </li>
                    <li>
                    Information provided in user-generated content or communications.
                    </li>
                    <li>
                    Any other information you choose to provide.
                    </li>
                </ul>
            </div>
            <div className="policy-sub-header">
            Use of personal information:
            </div>
            <div className="policy-text">
                We may use your personal information to:
                <ul>
                    <li>
                    Provide and improve the Website and Services.
                    </li>
                    <li>
                    Respond to your comments, questions, and requests.
                    </li>
                    <li>
                    Send you information about our products and services.
                    </li>
                    <li>
                    Monitor and analyze usage, and activities in connection with the Website and Services.
                    </li>
                    <li>
                    Personalize and improve the Website and Services.
                    </li>
                    <li>
                    Provide the desired functionality by you, the end users.
                    </li>
                </ul>
            </div>
            <div className="policy-sub-header">
            Sharing of personal information:
            </div>
            <div className="policy-text">
            We may share your personal information with:
                <ul>
                    <li>
                    Our affiliates and subsidiaries.
                    </li>
                    <li>
                    Service providers, such as website hosts, and email service providers.
                    </li>
                    <li>
                    Law enforcement, government agencies, or other third parties when we believe disclosure is necessary to comply with a legal obligation or to protect our rights, the rights of third parties, or the public at large.
                    </li>
                </ul>
            </div>
            <div className="policy-sub-header">
            Security of personal information:
            </div>
            <div className="policy-text">
            We take the security of your personal information seriously. We use a variety of security technologies and procedures to help protect your personal information from unauthorized access, use, or disclosure. For example, we store the personal information you provide on computer servers with limited access that are located in controlled facilities.
                    Accessing and updating personal information
            You may review and update your personal information by contacting us at the contact information provided below. We will respond to your request to access within 30 days.
            </div>
       </div>
       <div className="footer">
        <div className="policy-sub-header">
                    Contacting Us:
                </div>
                <div className="policy-text">
                    If you have any questions about this Policy, please contact us at <span style={{textDecoration:'underline',color:'blue'}}>saent@punjab.gov.pk</span> 
                </div>
        </div>
    </div>
    
 )
};

export default PrivacyPolicy;
